import ManageTraps from './ManageTraps'
import enhance from './ManageTraps.enhancer'

export default enhance(ManageTraps)

export const trapColumns = [
  {
    width: '23.3%', label: 'Trap Name', field: 'trapName', format: 'trapName'
  },
  {
    width: '23.3%', field: 'groupName', label: 'Group name', format: 'groupName', align: 'center'
  },
  {
    width: '23.3%', field: 'trapUsers', label: 'Trap Users', format: 'trapUsers', selectable: false, align: 'center'
  },
  {
    width: '30%', field: 'select', label: 'Select / Deselect all', selectable: false, format: 'checkbox', align: 'flex-end', labelAndCheckbox: true,
  }
]



// WEBPACK FOOTER //
// ./src/containers/traps/ManageTraps/index.js